import axios from "axios";
const apiUrl = process.env.REACT_APP_API_URL + "report/";

export const extractSales = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(
      `${apiUrl}extractsales`,
      payload,
      config
    );
    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API extractSales: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const filteredApplicationType = async () => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(`${apiUrl}filteredapplicationtype`, config);
    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API filteredApplicationType: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const filteredExtractFormat = async () => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(`${apiUrl}filteredextractformat`, config);
    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API filteredExtractFormat: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getCatalogItems = async () => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(`${apiUrl}getcatalogitems`, config);
    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getCatalogItems: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getListReport = async (agentCode) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(`${apiUrl}getlistreport?agentcode=${agentCode}`, config);
    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getListReport: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};
